import React from 'react';

/**
 * A wrapper for React.lazy that handles ChunkLoadError by refreshing the page.
 * This is useful when a new build is deployed and the browser tries to load old chunks.
 */
export const lazyWithRetry = (componentImport: () => Promise<any>) =>
  React.lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.localStorage.getItem('page-has-been-force-refreshed') || 'false'
    );

    try {
      const component = await componentImport();
      window.localStorage.setItem('page-has-been-force-refreshed', 'false');
      return component;
    } catch (error: any) {
      if (!pageHasAlreadyBeenForceRefreshed) {
        // Trigger a page refresh if a chunk fails to load
        window.localStorage.setItem('page-has-been-force-refreshed', 'true');
        return window.location.reload();
      }

      // If we already refreshed and it still fails, throw the error
      throw error;
    }
  });
